import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import Button from "@mui/material/Button";

type AppAssistenteIASugestoesProps = {
	readonly perguntas: readonly string[];
	readonly enviando: boolean;
	readonly onSelecionar: (pergunta: string) => void;
};

export default function AppAssistenteIASugestoes({ perguntas, enviando, onSelecionar }: AppAssistenteIASugestoesProps) {
	return (
		<div className="mt-1 grid gap-2 sm:grid-cols-2">
			{perguntas.map((pergunta, index) => (
				<Button
					key={pergunta}
					type="button"
					variant="outlined"
					color="secondary"
					size="small"
					disabled={enviando}
					startIcon={<FuseSvgIcon size={16}>lucide:message-circle-question</FuseSvgIcon>}
					className="animate-app-assistente-suggestion-in justify-start rounded-md border-secondary/30 bg-background/80 text-left normal-case opacity-0 transition-all duration-200 hover:-translate-y-0.5 hover:border-secondary hover:bg-secondary/10 hover:shadow-sm"
					style={{ animationDelay: `${index * 80}ms` }}
					onClick={() => onSelecionar(pergunta)}
				>
					{pergunta}
				</Button>
			))}
		</div>
	);
}
